/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import { useGLTF } from '@react-three/drei';

export function LamellaBase(props) {
  const { nodes, materials } = useGLTF('/lamellaBase.glb');
  return (
    <group dispose={null}>
      <mesh geometry={nodes.Cube.geometry} position={props.position} material={materials['Material.002']} scale={props.scale} rotation={[0, props.rotation, 0]} />
    </group>
  );
}

useGLTF.preload('/lamellaBase.glb');
